import { navLog } from '@lib/utils/navLog';
import useAuth from '@modules/AuthModule/hooks/useAuth';
import { useEffect, useState } from 'react';
import { RouterProvider, RouterProviderProps } from 'react-router-dom';

import sentryCreateBrowserRouter from '../modules/SentryModule/sentryCreateBrowserRouter';
import mainRoutes from './routes/mainRoutes';
import publicRoutes from './routes/publicRoutes';

const Router = () => {
  const { signedIn } = useAuth();
  const [router, setRouter] = useState<
    RouterProviderProps['router'] | undefined
  >();

  useEffect(() => {
    navLog({
      event: 'router-recreated',
      pathname: window.location.pathname,
      signedIn,
    });
    const routes = signedIn ? mainRoutes : publicRoutes;
    setRouter(sentryCreateBrowserRouter(routes));
  }, [signedIn]);

  if (!router) {
    return null;
  }

  return <RouterProvider router={router} />;
};

export default Router;
